import { Component } from '@angular/core';

@Component({
  selector: 'rr-invite',
  standalone: false,

  templateUrl: './invite.component.html',
  styleUrl: './invite.component.scss'
})
export class InviteComponent {

}
